export default {
      id: "ar_location_salle-usage",
      viewBox: "0 0 90 75",
      url: "../dist/images/" + "sprite.svg#ar_location_salle-usage",
      toString: function () {
        return this.url;
      }
    }